import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as LoveIcon } from '../../images/global/customer-love.svg';
import { ReactComponent as TickIcon } from '../../images/global/customer-tick.svg';
import StandardH4 from "../UI/StandardH4";
import styles from './SocialLove.module.scss';

const SocialLove = ({ isHotelCart }) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.cro1381SocialLove}>
      <div className={`${styles.cro1381SocialLoveContent} ${styles.cro1381SocialLoveContentHeading}`}>
        <div className={styles.icon}>
          <LoveIcon />
        </div>
        <div className={styles.content}>
          <StandardH4>{t('social-love-heading')}</StandardH4>
        </div>
      </div>
      <div className={styles.cro1381SocialLoveContent}>
        <div className={styles.icon}>
          <TickIcon />
        </div>
        <div className={styles.content}>
          <p>{t('social-love-content1')}</p>
        </div>
      </div>
      <div className={styles.cro1381SocialLoveContent}>
        <div className={styles.icon}>
          <TickIcon />
        </div>
        <div className={styles.content}>
          <p>{t('social-love-content2')}</p>
        </div>
      </div>
      <div className={styles.cro1381SocialLoveContent}>
        <div className={styles.icon}>
          <TickIcon />
        </div>
        <div className={styles.content}>
          {isHotelCart ? <p>{t('social-love-content5')}</p> : <p>{t('social-love-content3')}</p>}
        </div>
      </div>
      <div className={styles.cro1381SocialLoveContent}>
        <div className={styles.icon}>
          <TickIcon />
        </div>
        <div className={styles.content}>
          <p>{t('social-love-content4')}</p>
        </div>
      </div>
    </div>
  );
};

export default SocialLove;